import { Box } from '@superdispatch/ui-lab';
import { useField } from 'formik';
import { AuctionIcon } from 'shared/icons/business-type/AuctionIcon';
import { BusinessIcon } from 'shared/icons/business-type/BusinessIcon';
import { CarRentalIcon } from 'shared/icons/business-type/CarRentalIcon';
import { DealerIcon } from 'shared/icons/business-type/DealerIcon';
import { PortIcon } from 'shared/icons/business-type/PortIcon';
import { PrivateIcon } from 'shared/icons/business-type/PrivateIcon';
import { RepoYardIcon } from 'shared/icons/business-type/RepoYardIcon';
import { DriverPreferencesBanner } from '../DriverPreferencesBanner';
import { DriverPreferencesCheckboxList } from '../DriverPreferencesCheckboxList';

const PREFERENCES_CUSTOMER_TYPE_MAP = [
  {
    name: 'business',
    label: 'Business',
    icon: <BusinessIcon fontSize="small" />,
  },
  { name: 'auction', label: 'Auction', icon: <AuctionIcon fontSize="small" /> },
  {
    name: 'repo_yard',
    label: 'Repo Yard',
    icon: <RepoYardIcon fontSize="small" />,
  },
  { name: 'port', label: 'Port', icon: <PortIcon fontSize="small" /> },
  { name: 'dealer', label: 'Dealer', icon: <DealerIcon fontSize="small" /> },
  { name: 'private', label: 'Private', icon: <PrivateIcon fontSize="small" /> },
  {
    name: 'car_rental',
    label: 'Car Rental',
    icon: <CarRentalIcon fontSize="small" />,
  },
];

export function BusinessTypeStepContent() {
  const errorMessage = useField('preferred_business_locations')[1].error;

  return (
    <>
      <DriverPreferencesBanner text="Select preferred pickup and delivery locations by business type." />
      <Box padding="small" paddingRight="none">
        <DriverPreferencesCheckboxList
          items={PREFERENCES_CUSTOMER_TYPE_MAP}
          groupName="preferred_business_locations"
          errorMessage={errorMessage || ''}
        />
      </Box>
    </>
  );
}
